export enum NotificationVariant {
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Default = 'default',
  Info = 'info',
}
